import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd, NavigationStart, RouteConfigLoadStart, RouteConfigLoadEnd } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { DistributorsDataService } from '../../services/distributorsData/distributorsData.service';
import { LogoUpdateService } from 'src/app/services/logo-update.service';
import { ReleaseNotesData } from './release-notes/release-notes-dialog.component';
import { CookieService } from 'ngx-cookie-service';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
})
export class DashboardComponent implements OnInit {
  title = 'One-Tank';

  showSidebar: boolean = true;
  showNavbar: boolean = true;
  showFooter: boolean = true;
  showSettings: boolean = true;
  isLoading: boolean = false;
  logoUrl?: string;

  showReleaseNotes = false;
  releaseNotesData!: ReleaseNotesData;

    constructor(private router: Router, translate: TranslateService, 
      private _distributorDataService: DistributorsDataService,
      private cookieService: CookieService,
      private http: HttpClient,
      private logoUpdateService: LogoUpdateService) {

    // Removing Sidebar, Navbar, Footer for Documentation, Error and Auth pages
    router.events.forEach((event) => {
      if (event instanceof NavigationStart) {
        translate.use('en');
        document.querySelector('body')?.classList.remove('rtl');
        if ((event['url'] == '/user-pages/login') || (event['url'] == '/user-pages/login-2') || (event['url'] == '/user-pages/register') || (event['url'] == '/user-pages/register-2') || (event['url'] == '/user-pages/lock-screen') || (event['url'] == '/error-pages/404') || (event['url'] == '/error-pages/500')) {
          this.showSidebar = false;
          this.showNavbar = false;
          this.showFooter = false;
          this.showSettings = false;
          document.querySelector('.main-panel')?.classList.add('w-100');
          document.querySelector('.page-body-wrapper')?.classList.add('full-page-wrapper');
          if ((event['url'] == '/user-pages/login-2') || (event['url'] == '/user-pages/register-2')) {
            document.querySelector('.content-wrapper')?.classList.add('auth', 'auth-img-bg',);
          } else if (event['url'] == '/user-pages/lock-screen') {
            document.querySelector('.content-wrapper')?.classList.add('auth', 'lock-full-bg');
          } else {
            document.querySelector('.content-wrapper')?.classList.remove('auth', 'auth-img-bg',);
            document.querySelector('.content-wrapper')?.classList.remove('auth', 'lock-full-bg');
          }
          if ((event['url'] == '/error-pages/404') || (event['url'] == '/error-pages/500')) {
            document.querySelector('.content-wrapper')?.classList.add('p-0');
          }
        } else {
          this.showSidebar = true;
          this.showNavbar = true;
          this.showFooter = true;
          this.showSettings = true;
          document.querySelector('.main-panel')?.classList.remove('w-100');
          document.querySelector('.page-body-wrapper')?.classList.remove('full-page-wrapper');
          document.querySelector('.content-wrapper')?.classList.remove('auth', 'auth-img-bg');
          document.querySelector('.content-wrapper')?.classList.remove('p-0');
        }
      }
    });

    // Spinner for lazyload modules
  //  router.events.forEach((event) => {
  //    if (event instanceof RouteConfigLoadStart) {
  //      this.isLoading = true;
  //    } else if (event instanceof RouteConfigLoadEnd) {
  //      this.isLoading = false;
  //    }
  //  });
  }



    ngOnInit() {
        // Scroll to top after route change
        this.router.events.subscribe((evt) => {
            if (!(evt instanceof NavigationEnd)) {
                return;
            }
            window.scrollTo(0, 0);
        });

        this._distributorDataService.getDistributor$(Number(localStorage.getItem('distid') ?? "")).subscribe(d => {
            if (!d.logoUrl) {
                this.logoUrl = undefined;
                return;
            }
            this.logoUrl = `${d.logoUrl}?v=${Date.now()}`;
        });

        // Live updates
        this.logoUpdateService.logoUpdated$.subscribe(url => {
            if (!url) return;
            this.logoUrl = `${url}?v=${Date.now()}`;
        });

      this.http.get<ReleaseNotesData>('/api/release-notes').subscribe(notes => {
        const seen = this.cookieService.get('releaseNotesSeenVersion');

        if (!notes.version) {
          return;
        }

        const versionDate = new Date(notes.version.replace(/\./g, '-'));
        const now = new Date();
        const daysOld = (now.getTime() - versionDate.getTime()) / (1000 * 60 * 60 * 24);
        const isRecent = daysOld <= 7; // show only if release is <= 7 days old

        if (isRecent && seen !== notes.version) {
          this.releaseNotesData = notes;
          this.showReleaseNotes = true;
        }
      });
    }
    
    onDialogClosed() {
        this.showReleaseNotes = false;
    }

  }
